import { render, staticRenderFns } from "./AdsModal.vue?vue&type=template&id=e440ffa2&scoped=true"
import script from "./AdsModal.vue?vue&type=script&lang=js"
export * from "./AdsModal.vue?vue&type=script&lang=js"
import style0 from "./AdsModal.vue?vue&type=style&index=0&id=e440ffa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e440ffa2",
  null
  
)

export default component.exports